/* eslint-disable object-curly-newline */
import { Link, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useMemoRef } from 'platform/react/hook'
import Icon from 'ui/Element/Icon'

/**
 * Acl Menu Item Component
 *
 * @example default menu entry
 * {
 *   options: { key: 'profile', label: 'Profile', icon: '' },
 *   route: { module: 'user', action: 'profile' },
 *   acl: { user: [20] },
 *   aclProps: { disabled: true },
 * }
 *
 * @param forwardedRef      forwarded ref
 * @param child             the menu item
 * @param options           options for the component
 * @returns {JSX.Element}
 */
const AclMenuItem = ({ forwardedRef, child, options }) => {
  const { icon, label, context, selected, disabled, route: { module, action } } = child
  const { props, events: { onClick } } = options

  return (
    <MenuItem
      ref={forwardedRef}
      onClick={onClick}
      disabled={disabled || selected}
      {...props}
    >
      <Link
        underline={'hover'}
        href={`/#/${context}/${module}/${action}`}
      >
        {icon && (
          <ListItemIcon>
            <Icon name={icon} />
          </ListItemIcon>
        )}
        <ListItemText primary={label}/>
      </Link>
    </MenuItem>
  )
}

export default useMemoRef(AclMenuItem)
